import styles from './sidebar.module.scss';
import { NavLink } from 'react-router-dom';
import { Accordion, AccordionDetails, AccordionSummary, List } from '@material-ui/core';
import classNames from 'classnames';
import { Path } from 'enums';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useContext } from 'react';
import { UserContext } from 'contexts';

const Navigation = [
  {
    label: 'Dashboard',
    link: Path.Slash,
    exact: true
  },
  {
    label: 'Chart of Accounts',
    link: Path.Account,
    exact: true,
    needValidate: true
  },
  {
    label: 'Transaction Entry',
    link: `${Path.Transaction}/entry`,
    exact: true
  },
  {
    label: 'Books of Accounts',
    link: Path.BooksOfAccounts,
    needValidate: true,
    items: [
      {
        label: 'General Entries Book',
        link: `${Path.BooksOfAccounts}/general-entries`,
        child: false
      },
      {
        label: 'Cash Disbursement Book',
        link: `${Path.BooksOfAccounts}/cash-disbursement`,
        child: false
      },
      {
        label: 'Cash Receipt Book',
        link: `${Path.BooksOfAccounts}/cash-receipt`,
        child: false
      },
      {
        label: 'General Journal',
        link: `${Path.BooksOfAccounts}/general-journal`,
        child: false
      },
      {
        label: 'General Ledger',
        link: `${Path.BooksOfAccounts}/general-ledger`,
        child: false
      }
    ]
  },
  {
    label: 'Trial Balance',
    link: Path.TrialBalance,
    exact: true,
    needValidate: true
  },
  {
    label: 'Users',
    link: Path.Users,
    exact: true,
    needValidate: true
  }
];

const ChildItem = (props) => {
  const { item } = props;
  const parent = (
    <NavLink
      to={item.link}
      className={classNames(styles.listItem, {
        [`${styles.enabledLink}`]: !item?.items?.length,
        [`${styles.disabledLink}`]: item?.items?.length
      })}
      activeClassName={classNames(item, styles.selectedMenu)}
    >
      <span className={styles.item}>
        <span className={styles.listText}>{item.label}</span>
      </span>
    </NavLink>
  );
  return (
    <Accordion elevation={0}>
      {item?.items?.length ? (
        <AccordionSummary expandIcon={<ExpandMoreIcon className={styles.expandIcon} />}>{parent}</AccordionSummary>
      ) : (
        <></>
      )}
      <AccordionDetails>
        <div className={styles.child}>
          {item.items.map((child, childKey) => {
            return (
              <NavLink key={childKey} to={child.link} className={classNames(styles.listItem)} activeClassName={styles.active}>
                <span className={styles.listIconRoot}>{child.icon && <span className={`icon ${child.icon}`} />}</span>
                <span className={styles.listText}>{child.label}</span>
              </NavLink>
            );
          })}
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

const Sidebar = () => {
  const user = useContext(UserContext);
  const isAdmin = ['admin', 'super-admin'].includes(user?.role);

  return (
    <div className={styles.sidebarContainer}>
      <List className={styles.sidebarList}>
        {Navigation.map((item, index) => {
          if (!item || (item.needValidate && !isAdmin)) return <></>;

          return (
            <span key={index}>
              {item.exact ? (
                <NavLink to={item.link} exact={true} className={classNames(styles.listItem)} activeClassName={styles.active}>
                  <span className={styles.item}>
                    <span className={styles.listText}>{item.label}</span>
                  </span>
                </NavLink>
              ) : (
                <ChildItem item={item} />
              )}
            </span>
          );
        })}
      </List>
    </div>
  );
};

export default Sidebar;
